import { getCurrentAdScenario } from "@/hooks/useAdScenario";
import { getImg } from "@/utils";
import classNames from "classnames";

export default function Ads1(props: any) {
  const {
    slot,
    style,
    client = "ca-pub-8823204853280729",
    className = "adsbygoogle",
    isLazyLoad = true, // 新增懒加载开关，默认开启
    rootMargin = "100px 0px 100px 0px", // 新增根边距配置
    dataPosition,
  } = props;
  const { isTranTabAdScenario } = getCurrentAdScenario();
  const [isClosed, setIsClosed] = useState(false);
  if (isTranTabAdScenario) {
    import("./style.css");
  }
  // 广告容器引用
  const adsContainerRef = useRef<HTMLDivElement>(null);
  // 观察器引用
  const observerRef = useRef<IntersectionObserver | null>(null);
  // 标记是否进入视口
  const [isInView, setIsInView] = useState(false);
  const hasLoadedRef = useRef(false);
  const [adStatus, setAdStatus] = useState<"idle" | "pending" | "filled" | "unfilled">("idle");
  const slotHeightValue = String(style?.height ?? style?.minHeight ?? "0");
  const slotHeightMatch = slotHeightValue.match(/(\d+(?:\.\d+)?)/);
  const slotHeight = slotHeightMatch ? `${slotHeightMatch[1]}px` : "0px";

  const syncAdStatus = () => {
    const adNode = adsContainerRef.current?.querySelector<HTMLElement>("ins.adsbygoogle");
    const nextStatus = adNode?.getAttribute("data-ad-status");
    if (nextStatus === "filled" || nextStatus === "unfilled") {
      setAdStatus(nextStatus);
      return;
    }
    if (adNode && hasLoadedRef.current) {
      setAdStatus(prev => (prev === "filled" || prev === "unfilled" ? prev : "pending"));
      return;
    }
    setAdStatus(hasLoadedRef.current ? "pending" : "idle");
  };

  // 清理观察器
  const unobserveAd = () => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
  };

  // 原有的广告加载逻辑提取成独立函数
  const loadAd = () => {
    try {
      setAdStatus(prev => (prev === "filled" ? prev : "pending"));
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      console.log("ads广告代码执行了:", slot);
    } catch (error) {
      console.error("广告加载失败:", error);
      setAdStatus("unfilled");
    }
  };

  // ins 渲染后再 push（懒加载时原先在 ins 挂载前就 push，底部最后一个广告位最易失败）
  useEffect(() => {
    if (!isInView || hasLoadedRef.current) return;
    hasLoadedRef.current = true;
    loadAd();
  }, [isInView]);

  // 说明：Google 会异步给 ins 打上 data-ad-status，组件自己跟踪 filled 状态，
  // 避免关闭按钮在样式加载和广告状态切换之间先闪一下再显示。
  useEffect(() => {
    const container = adsContainerRef.current;
    if (!container) return;

    syncAdStatus();
    const observer = new MutationObserver(() => {
      syncAdStatus();
    });

    observer.observe(container, {
      attributes: true,
      attributeFilter: ["data-ad-status"],
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [isInView, isLazyLoad]);

  // 设置观察器
  const observeAd = () => {
    if (!isLazyLoad) {
      setIsInView(true);
      return;
    }

    // 创建观察器
    observerRef.current = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasLoadedRef.current) {
            console.log("广告元素进入视口:", slot);
            setIsInView(true);
            unobserveAd(); // 加载后取消观察
          }
        });
      },
      {
        rootMargin,
        threshold: 0.0,
      },
    );

    // 开始观察容器元素
    if (adsContainerRef.current) {
      observerRef.current.observe(adsContainerRef.current);
    }
  };

  // 组件挂载时设置观察器
  useEffect(() => {
    observeAd();

    // 组件卸载时清理观察器
    return () => {
      unobserveAd();
    };
  }, []);

  const adContent = (
    <div ref={adsContainerRef} style={{ textAlign: "center" }} className="google-ad-ads center">
      {/* 只有进入视口或不使用懒加载时才渲染广告标签 */}
      {isInView || !isLazyLoad ? (
        <ins className={className} style={style} data-ad-client={client} data-ad-slot={slot}></ins>
      ) : null}
    </div>
  );
  const shouldShowTranCloseBar = adStatus === "filled";
  const tranWrapperClassName = classNames([
    "ad-section-wrapper",
    adStatus === "pending" && "is-pending",
    adStatus === "filled" && "is-filled",
    adStatus === "unfilled" && "is-empty",
  ]);
  const tranWrapperStyle = {
    "--tran-ad-slot-height": slotHeight,
  } as any;

  if (isTranTabAdScenario) {
    return (
      !isClosed && (
        <div className={tranWrapperClassName} data-position={dataPosition} style={tranWrapperStyle}>
          {shouldShowTranCloseBar ? (
            <div className={classNames(["ad-tran-close-bar bg-#f0f0f0 h-4 relative"])}>
              <img
                src={getImg("close_ad.png")}
                alt=""
                className="rotate-180 absolute right-0 top-[0px]"
                style={{
                  width: "37px",
                  height: "21px",
                  top: "-21px",
                }}
                onClick={() => setIsClosed(true)}
              />
            </div>
          ) : null}
          <div className="ad-tran-content">{adContent}</div>
        </div>
      )
    );
  }

  return adContent;
}
